import { useMemo, useState } from "react";
import { Menu, MenuButton, MenuList } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import useScreenType from "react-screentype-hook";
import queryString from "query-string";

import ProfileMenu from "./ProfileMenu";
import { Bell, HamburgerIcon } from "../../Assets/SvgIcons";
import { AddMemberIcon } from "../../Assets/SvgIcons";
import { AddMemberButton, AddMemberText, TextBadgeContainer } from "./Styles";
import { NotificationMenuList, NotificationScrollArea } from "./NotificationStyles";

import { TextBadge } from "../Sidebar/Styles";
import { useGetNotificationsQuery, useGetProfileQuery } from "../../../redux/reducers/apiSlice";
import { Notification } from "./Notification";
import { Button as UIButton } from "../../Components/ui/button";
import UpgradeModal from "./UpgradeModal";
import { Sparkles } from "lucide-react";

const AnyMenuButton: any = MenuButton;
const AnyMenuList: any = MenuList;

const HeaderRight = ({ toggleSidebar }) => {
  const location = useLocation();
  const { isMobile } = useScreenType();
  const [isUpgradeOpen, setIsUpgradeOpen] = useState(false);

  const navigate = useNavigate();
  const { data: notificationsData } = useGetNotificationsQuery(undefined, { pollingInterval: 5*60*1000 });
  const { data: currentProfileData } = useGetProfileQuery();
  const newNotifications = useMemo(() => {
    return notificationsData?.filter(
      (notification) => notification.status === "NEW"
    );
  }, [notificationsData]);
  const hasNotifications = Boolean(
    notificationsData && notificationsData.length > 0
  );
  const hasNewNotifications = Boolean(
    newNotifications && newNotifications.length > 0
  );

  const onAddMemberClicked = () => {
    const parsedQueryStrings = queryString.parse(location.search);
    parsedQueryStrings["inviteModalOpen"] = "true";
    const hasQuestionMark =
      Object.keys(parsedQueryStrings).length > 0 ? "?" : "";

    navigate(
      `${location.pathname}${hasQuestionMark}${queryString.stringify(
        parsedQueryStrings
      )}`
    );
  };

  return (
    <div className="profile-container">
      <div className="header-upgrade-wrap">
        <UIButton
          type="button"
          variant="default"
          className="header-upgrade-btn"
          aria-label={
            currentProfileData?.subscription_tier === "PAID"
              ? "Manage plan"
              : "Upgrade my account"
          }
          onClick={() => setIsUpgradeOpen(true)}
        >
          <Sparkles className="header-upgrade-icon" aria-hidden size={18} />
          <span className="header-upgrade-text-full">
            {currentProfileData?.subscription_tier === "PAID"
              ? "Manage plan"
              : "Upgrade my account"}
          </span>
          <span className="header-upgrade-text-short" aria-hidden>
            {currentProfileData?.subscription_tier === "PAID" ? "Plan" : "Upgrade"}
          </span>
        </UIButton>
      </div>
      {isMobile &&
        location.pathname.includes("/organizations") &&
        location.pathname !== "/organizations/new" &&
        !location.pathname.includes("profile") && (
          <div>
            <AddMemberButton onClick={() => onAddMemberClicked()}>
            <AddMemberIcon />
            <AddMemberText>Invite member</AddMemberText>
          </AddMemberButton>
          </div>
      )}
      <div className="box-notification">
        <Menu placement="bottom-end">
          <AnyMenuButton
            className="header-notification-trigger"
            onClick={() => {}}
            disabled={!hasNotifications}
          >
            <Bell
              color={hasNotifications ? "#000" : "#aaa"}
              className="bell"
            />

            <TextBadgeContainer
              $isVisible={hasNewNotifications}
            >
              <TextBadge>{newNotifications?.length}</TextBadge>
            </TextBadgeContainer>
          </AnyMenuButton>
          {hasNewNotifications && (
            <AnyMenuList p={0} borderRadius="16px" overflow="hidden">
              <NotificationMenuList>
                <NotificationScrollArea>
                {notificationsData &&
                  notificationsData.map((notification) => {
                    return (
                      <div key={notification.id}>
                        <Notification notification={notification} />
                      </div>
                    );
                  })}
                </NotificationScrollArea>
              </NotificationMenuList>
            </AnyMenuList>
          )}
        </Menu>
      </div>

      <div className="profile-menu">
        <ProfileMenu />
      </div>
      <div className="hamburger-menu">
        <button
          type="button"
          className="header-hamburger-trigger"
          aria-label="Open menu"
          onClick={() => toggleSidebar()}
        >
          <HamburgerIcon boxSize={25} />
        </button>
      </div>

      {isUpgradeOpen && (
        <UpgradeModal
          isOpen={isUpgradeOpen}
          onClose={() => setIsUpgradeOpen(false)}
        />
      )}
    </div>
  );
};

export default HeaderRight;
